export default {
  Base: {
    BaseContent: '知识库内容',
    monthAgeSegment: '月龄段',
    ApplicableLabels: '适用标签',
    addKnowledgeBase: '新增知识库',
    editKnowledgeBase: '修改知识库',
    feedingPattern: '适合喂养方式'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/mmc/knowledgeBase.js